/*
 * @Author: edvardchen
 * @Date:   2016-11-17 12:53:36
 * @Last Modified by:   edvardchen
 * @Last Modified time: 2016-12-26 19:57:19
 */

import React from 'react';
import PropTypes from 'prop-types';
import autobind from 'core-decorators/lib/autobind';

import VideoPlayInLine from '../VideoPlayInLine';

import { video as service } from '../../fetchers';
import { getImageDimension, number2percent } from '../../utility';

export default class ArticleVideo extends React.Component {
  static propTypes = {
    poster: PropTypes.string,
    src: PropTypes.string,
    label: PropTypes.string,
    title: PropTypes.string,
    vid: PropTypes.string,
    ratio: PropTypes.number,
    onPlay: PropTypes.func,
    children: PropTypes.element,
    hideTitle: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      src: props.src,
      title: props.title,
      ratio: props.ratio,
    };
  }

  componentDidMount() {
    if (!this.state.ratio && this.props.poster) {
      getImageDimension(this.props.poster).then(({ width, height }) => {
        const ratio = height / width;
        this.setState({
          ratio,
        });
      });
    }
    service
      .fetchQQVideoPlayUrl({
        vid: this.props.vid,
        isAndroid: true,
      })
      .then(({ url, title }) => {
        this.setState({
          src: url,
          title,
        });
      });
  }

  @autobind
  onPlay() {
    const { onPlay } = this.props;
    if (onPlay) {
      onPlay({
        vid: this.props.vid,
        ...this.state,
      });
    }
  }

  render() {
    const { poster, label, children, hideTitle } = this.props;
    const { title, src, ratio } = this.state;

    const layer = label && (
      <div className="layer">
        <span className="tag">{label}</span>
      </div>
    );
    if (!src || !ratio) {
      return null;
    }
    const heightStyle = {
      paddingBottom: number2percent(ratio),
    };
    return (
      <div className="pic-wrap mod-news-text-video">
        <div className="img-container" style={heightStyle}>
          <VideoPlayInLine src={src} poster={poster} controls onPlay={this.onPlay} />
          {layer}
        </div>
        {!hideTitle && title ? <div className="img-info">{title}</div> : null}
        {children}
      </div>
    );
  }
}
